import {createKeyframes, createViewConfig} from '@sail/engine';
import {tokens} from '../tokens';

const shimmer = createKeyframes({
  from: {
    backgroundPosition: '200% center',
  },
  to: {
    backgroundPosition: '0 center',
  },
});

export const SkeletonConfig = createViewConfig({
  name: 'Skeleton',
  props: {},
  flattens: true,
});

export const Skeleton = SkeletonConfig.createView('div', {
  css: {
    animation: `${shimmer} 1400ms ease-in-out 0ms infinite both`,
    backgroundImage: `linear-gradient(
        to right,
        ${tokens.color.background.offset} 50%,
        ${tokens.color.background.surface} 80%,
        ${tokens.color.background.offset} 100%
      )`,
    backgroundSize: '200% 100%',
    borderRadius: 'xsmall',
    height: 'medium',
    width: 'xxlarge',
  },
  defaults: {'data-testid': 'skeleton'},
});
